// React
import { Dispatch, ReactElement, SetStateAction } from 'react';
// Styles

import * as React from 'react';

import { Modal } from '@utmb/design-system/modal/Modal';
import { HorizontalAlignEnum, VerticalAlignEnum } from '@utmb/types/modal';
import MyModalFooter from '@utmb/features/my-modal-footer/MyModalFooter';
import { BusReservationRunner } from '@utmb/features/bus-reservation/BusReservationRunner';

interface RegistrationServiceModalProps {
    isOpen: boolean;
    close: Dispatch<SetStateAction<boolean>>;
    raceYearId: number;
    tenant: string;
    year: number;
}

export const RegistrationServiceModal = (props: RegistrationServiceModalProps): ReactElement => {
    const { isOpen, close, raceYearId, tenant, year } = props;
    return (
        <Modal isOpen={isOpen} onClose={close} vAlign={VerticalAlignEnum.TOP} hAlign={HorizontalAlignEnum.RIGHT}>
            <BusReservationRunner raceYearId={raceYearId} tenant={tenant} year={year} />
            <MyModalFooter />
        </Modal>
    );
};
